import { MaasSystemConfigSection } from './MaasSystemConfigSection';
import type { MaasSystemConfigBlockProps } from './types';

/** 模型实例系统配置能力块：推理框架 / 镜像 */
export function MaasSystemConfigBlock({ form, options }: MaasSystemConfigBlockProps) {
  return (
    <MaasSystemConfigSection
      form={form}
      isEdit={options?.isEdit}
      initValues={options?.initValues}
      presetArchitecture={options?.presetArchitecture}
      presetImageLocked={options?.presetImageLocked}
      lockActionsWhenFilled={options?.lockActionsWhenFilled}
      customImageOnly={options?.customImageOnly}
    />
  );
}
